import React from 'react';

/**
 * Page shell: header bar, then a fixed-width left column (payment) beside the main column of cards.
 *
 * The grid lives here rather than in CamperDetail.js because tailwind.config.js only scans this
 * folder; tw- classes written in CamperDetail.js would never be generated.
 *
 * On narrow screens the sidebar stacks after the main column, so participant details come first.
 * From `lg` the sidebar is its own scroll area: sticky below the site's fixed header (~130px) and
 * capped at the viewport height, so the section nav and payment stay reachable while the cards
 * scroll. `overscroll-contain` stops the page jumping when the sidebar reaches its end.
 */
const BookingDetailLayout = ({ header, sidebar, children }) => (
    <div className="tw-flex tw-flex-col tw-gap-5">
        {header}
        <div className="tw-grid tw-grid-cols-1 tw-items-start tw-gap-6 lg:tw-grid-cols-[360px_minmax(0,1fr)]">
            <div className="tw-min-w-0 max-lg:tw-order-last lg:tw-sticky lg:tw-top-36 lg:tw-max-h-[calc(100vh-10rem)] lg:tw-overflow-y-auto lg:tw-overscroll-contain lg:tw-pr-1">{sidebar}</div>
            <div className="tw-flex tw-min-w-0 tw-flex-col tw-gap-6">{children}</div>
        </div>
    </div>
);

export default BookingDetailLayout;
